import { makeStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles'

const styles = (color) =>
  makeStyles((theme) => ({
    chip: {
      backgroundColor: color.background || theme.palette.white,
      border: `1px solid ${fade(color.main, 0.3)}`,
      color: color.main,
      borderRadius: 20,
      fontWeight: 600,
      height: 32,
    },
    label: {
      paddingLeft: theme.spacing(1),
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: color.main,
      marginLeft: theme.spacing(1.5),
    },
  }))

export default styles
